import { render, staticRenderFns } from "./actionButton.vue?vue&type=template&id=5685a4a5&scoped=true&"
import script from "./actionButton.vue?vue&type=script&lang=js&"
export * from "./actionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685a4a5",
  null
  
)

export default component.exports